import { defineMessages } from 'react-intl';

interface Message {
  id: string;
  defaultMessage: string;
}

interface OtpSelectableMessage {
  [key: string]: Message;
}

export const messages: OtpSelectableMessage = defineMessages({
  title: {
    defaultMessage: 'Select verification method',
    id: 'OtpMethod.title',
  },
  subtitle: {
    defaultMessage: 'To continue, select how you would like to verify your identity.',
    id: 'OtpMethod.subtitle',
  },
  call: {
    defaultMessage: 'Call me',
    id: 'OtpSelectableOption.call',
  },
  text: {
    defaultMessage: 'Text me',
    id: 'OtpSelectableOption.text',
  },
  email: {
    defaultMessage: 'Email me',
    id: 'OtpSelectableOption.email',
  },
  unknown: {
    defaultMessage: 'Other verification method',
    id: 'OtpSelectableOption.unknown',
  },
});
